import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { UserControllerDeleteRequestConfigureOtpParameter } from '../parameters/user-controller-delete-request-configure-otp.parameter';
import { UserControllerDeleteRequestConfigureOtpResponse } from '../responses/user-controller-delete-request-configure-otp.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'user-controller-deleteRequestConfigureOtp',
    operation: '{"operationId":"user-controller-deleteRequestConfigureOtp","parameters":[{"name":"userUuid","in":"path","required":true,"schema":{"type":"string","format":"uuid"}}],"responses":{"200":{"content":{"application/json":{"schema":{"type":"object"}}}}},"method":"delete","path":"/user-controller/{userUuid}/request-configure-otp"}'
  })
export class UserControllerDeleteRequestConfigureOtpRemoteMethod extends OpenApiRemoteMethod<UserControllerDeleteRequestConfigureOtpResponse, UserControllerDeleteRequestConfigureOtpParameter, void> {
  public override call(parameters: OpenApiRemoteMethodParameter<UserControllerDeleteRequestConfigureOtpParameter, void>): Promise<UserControllerDeleteRequestConfigureOtpResponse> {
    return super.call(parameters);
  }
}
